<div class="container">
    <img class="ops" src="../../assets/404.svg" />
    <div class="space"></div>
    <h2>Algo correu mal!</h2>
        <h3> Página não encontrada</h3>
        <div class="space"></div>
    <a class="buton" routerLink="/">Voltar ao Início</a>
</div>